export default __webpack_public_path__ + "static/media/footer-rebrand-vertical.376a950e.svg";